import pagination from '@/helpers/pagination';
import view from './view/model';

export default {
    ...pagination('requestList').model,
    view,
};
